/** Determines whether the user's device is running on iOS. */
export default function iosIs(): boolean
{
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}
